import { useEffect } from 'react';
import { useService } from '~/services/service.base';
import { ServicePaginator } from '~/services/service.paginator';
import { runInAction } from 'mobx';
export const usePagination = (offset) => {
    const paginatorService = useService(ServicePaginator);
    useEffect(() => {
        const onScroll = (event) => {
            const [child] = event.target?.children || [];
            if (child.scrollHeight - child.scrollTop === child.clientHeight) {
                runInAction(() => {
                    paginatorService.setOffset(offset);
                });
            }
        };
        document.removeEventListener('scroll', onScroll);
        document.addEventListener('scroll', onScroll, { passive: true });
        return () => document.removeEventListener('scroll', onScroll);
    }, [offset, paginatorService]);
};
